import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaWhatsapp, FaDownload, FaPen, FaSave, FaShareAlt } from "react-icons/fa";
import axios from "axios";
import { API_BASE_URL } from "../config/constants";
import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";


const TransactionGrid = () => {
  const [data, setData] = useState([]);
  const [visibleDataCount, setVisibleDataCount] = useState(7);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteBookingId, setDeleteBookingId] = useState(null);
  const [showDateConfirmPopup, setShowDateConfirmPopup] = useState(false);
  const [editingBookingId, setEditingBookingId] = useState(null);
  const [newTripDate, setNewTripDate] = useState("");
  const navigate = useNavigate();

  const [showShareOptions, setShowShareOptions] = useState(null);

  const handleShare = (bookingId) => {
    setShowShareOptions(showShareOptions === bookingId ? null : bookingId);
  };

  const shareToWhatsApp = (item) => {
    const message = `Booking Details:
    Booking Ref Number : ${item.BOOKING_REFERENCE_NO}
    Status: ${item.STATUS}
    Date: ${item.TRIP_DATE}
    Destination: ${item.DESTINATION}
    Amount: Rs. ${item.AMOUNT}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const downloadPDF = (item) => {
    const doc = new jsPDF({
      format: "a5",
      orientation: "portrait"
    });

    const logoUrl = "/images/CIAL_Logo.png";
    const logoWidth = 15;
    const logoHeight = 15;
    doc.addImage(logoUrl, "PNG", 15, 10, logoWidth, logoHeight);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Booking Details", 72, 20, { align: "center" });

    const canvas = document.createElement("canvas");
    JsBarcode(canvas, item.BOOKING_REFERENCE_NO, {
      format: "CODE128",
      displayValue: false,
      fontSize: 12,
      height: 18,
      width: 1.2,
    });

    const barcodeImage = canvas.toDataURL("image/png");

    doc.addImage(barcodeImage, "PNG", 110, 12, 25, 15);

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(15, 30, 132, 30);



    const data = [
      ["Trip Date", item.TRIP_DATE],
      ["Booking Date", item.ADD_DATE],
      ["Terminal", item.STAND_COUNTER || "N/A"],
      ["Booking Ref Number", item.BOOKING_REFERENCE_NO],
      ["Passenger Name", item.NAME_OF_PASSENGER || "N/A"],
      ["No. of Adults", item.PASSENGER_COUNT || "N/A"],
      ["No. of Children", item.KIDS_COUNT || "N/A"],
      ["Large Baggage", item.LARGE_BAG || "N/A"],
      ["Medium Baggage", item.MEDIUM_BAG || "N/A"],
      ["Cabin Baggage", item.CABIN_BAG || "N/A"],
      ["Destination", item.DESTINATION],
      ["Total Distance", item.TRIP_DISTANCE + parseFloat(item.ADJUST_DISTANCE || 0) || "N/A"],
      ["Additional Distance", item.ADJUST_DISTANCE || "N/A"],
      ["Waiting Time", item.WAIT_MINUTE || "N/A"],
      ["Total Cost", item.AMOUNT + " /-" || "N/A"]
    ];

    const margin = 25;
    const columnWidths = [45, 50];
    const rowHeight = 8;
    let yOffset = 40;



    // Add Table Rows
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    for (let row = 0; row < data.length; row++) {
      for (let col = 0; col < data[row].length; col++) {
        doc.text(String(data[row][col]), margin + col * columnWidths[col], yOffset);
      }
      yOffset += rowHeight;
    }

    // Footer Text
    const footerText = `Note: This is only a provisional booking confirmation and not a valid proof for the travel.
Passenger should collect the receipt and vehicle allocation details through self-service KIOSK or prepaid taxi
counter at the airport.

For any query or feedback

Mobile: +91-9539001082 (International Terminal)  +91-9539001042 (Domestic Terminal)

Email: ciatocs@cial.aero`;

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.text(footerText, 72, 170, {
      maxWidth: 120,
      align: "center"
    });


    doc.save(`Booking_${item.BOOKING_REFERENCE_NO}.pdf`);

    // const pdfBlob = doc.output("blob");
    // const pdfURL = URL.createObjectURL(pdfBlob);

    // const a = document.createElement("a");
    // a.href = pdfURL;
    // a.download = `Booking_${item.CLNT_TXN_REF}.pdf`;
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // window.open(pdfURL, "_blank");
  };





  const fetchData = async () => {
    try {
      const storedId = sessionStorage.getItem("id");
      const token = sessionStorage.getItem("token");

      if (!storedId || !token) {
        setErrorMessage("No ID or token found in sessionStorage.");
        setLoading(false);
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`${API_BASE_URL}booking-list-token/${storedId}`, { headers });

      if (response.data && response.data.data) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const formattedData = response.data.data
          .filter((item) => {
            const tripDate = new Date(item.TRIP_DATE);
            tripDate.setHours(0, 0, 0, 0);
            return item.STATUS === "A";
            return item.STATUS === "A" && tripDate >= today;
          })
          .map((item) => {
            const tripDate = new Date(item.TRIP_DATE);
            const formattedDate = `${("0" + tripDate.getDate()).slice(-2)}-${("0" + (tripDate.getMonth() + 1)).slice(-2)}-${tripDate.getFullYear()}`;
            const addDate = new Date(item.ADD_DATE);
            const formattedaDate = `${("0" + addDate.getDate()).slice(-2)}-${("0" + (addDate.getMonth() + 1)).slice(-2)}-${addDate.getFullYear()}`;
            return {
              ...item,
              STATUS: "Active",
              TRIP_DATE: formattedDate,
              ADD_DATE: formattedaDate,
              isEditing: false,
              date: formattedDate,
            };
          });


        setData(formattedData);
      } else {
        setErrorMessage(response.data.message || "No bookings found.");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setErrorMessage("Your session has expired. Please log in again.");
        navigate("/login");
      } else {
        setErrorMessage("No Bookings Found!.");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [navigate]);

  const handleEdit = (PK_BOOKING_ID) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.PK_BOOKING_ID === PK_BOOKING_ID ? { ...item, isEditing: true } : item
      )
    );
  };

  const confirmDateChange = (PK_BOOKING_ID, TRIP_DATE) => {
    setEditingBookingId(PK_BOOKING_ID);
    setNewTripDate(TRIP_DATE);
    setShowDateConfirmPopup(true);
  };

  const handleSave = async () => {
    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        setErrorMessage("No token found in sessionStorage.");
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };

      const [day, month, year] = newTripDate.split("-");
      const formattedDate = `${day}-${month}-${year}`;

      const response = await axios.post(
        `${API_BASE_URL}booking-edit-token`,
        {
          bookingID: editingBookingId,
          tripDate: formattedDate
        },
        { headers }
      );

      if (response.data && response.data.code === 201) {
        setData((prevData) =>
          prevData.map((item) =>
            item.PK_BOOKING_ID === editingBookingId
              ? {
                ...item,
                date: formattedDate,
                TRIP_DATE: formattedDate,
                isEditing: false,
              }
              : item
          )
        );
        setShowDateConfirmPopup(false);
        setEditingBookingId(null);
      } else {
        setErrorMessage(response.data.message || "Failed to update booking.");
      }
    } catch (error) {
      console.error("Error during update API call:", error);
      setErrorMessage("An error occurred while updating booking details.");
    }
  };

  const handleCancelDateChange = () => {
    setShowDateConfirmPopup(false);
    setEditingBookingId(null);
    setNewTripDate("");
  };

  const confirmDelete = (TRIP_DATE) => {
    setShowDeletePopup(true);
    setDeleteBookingId(TRIP_DATE);
    fetchData();
  };

  const handleDelete = async () => {
    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        setErrorMessage("No token found in sessionStorage.");
        setShowDeletePopup(false);
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };

      setData((prevData) =>
        prevData.map((item) =>
          item.TRIP_DATE === deleteBookingId
            ? { ...item, STATUS: "Cancelled" }
            : item
        )
      );

      const response = await axios.post(
        `${API_BASE_URL}booking-delete-token`,
        { bookingID: deleteBookingId },
        { headers }
      );

      if (response.data && response.data.code === 201) {
        setShowDeletePopup(false);
        setDeleteBookingId(null);
        fetchData();
      } else {
        setErrorMessage(response.data.message || "Failed to delete booking.");
        setShowDeletePopup(false);
      }
    } catch (error) {
      console.error("Error during delete API call:", error);
      setErrorMessage("An error occurred while deleting booking details.");
      setShowDeletePopup(false);
    }
  };

  const handleCancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteBookingId(null);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filteredData = data.filter((item) =>
      item.BOOKING_REFERENCE_NO.toString().toLowerCase().includes(query.toLowerCase()) ||
      item.STATUS.toLowerCase().includes(query.toLowerCase()) ||
      item.date.toLowerCase().includes(query.toLowerCase()) ||
      item.DESTINATION.toLowerCase().includes(query.toLowerCase()) ||
      item.AMOUNT.toString().toLowerCase().includes(query.toLowerCase())
    );
    setData(filteredData);
  };

  const handleLoadMore = () => {
    setVisibleDataCount((prevCount) => prevCount + 7);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleContainerClick = () => {
    if (isDrawerOpen) {
      setIsDrawerOpen(false);
    }
  };

  return (
    <div className="transaction-grid-container" onClick={handleContainerClick}>
      <header className="navbar-journey">
        <img onClick={() => navigate("/booking")} src="/images/CIAL_Logo.png" alt="Logo" className="logo" />
        <h1 className="heading">
          WELCOME TO <span className="cial-highlight">CIAL</span> ONLINE TAXI BOOKING
        </h1>
        <FaBars className="hamburger-icon" onClick={toggleDrawer} />
      </header>

      {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      <div className="content-journey">
        <h5>Upcoming Journey Details</h5>
        <div className="search-container">
          <input
            type="text"
            className="search-bar"
            placeholder="Search here"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="transaction-grid">
        {loading ? (
          <p>Loading...</p>
        ) : errorMessage ? (
          <p className="error-message">No Bookings Available!</p>
        ) : (
          <>
            <div className="grid-header">
              <div className="header-item">Booking Ref Number</div>
              <div className="header-item">Status</div>
              <div className="header-item">Date</div>
              <div className="header-item">Destination</div>
              <div className="header-item">Amount</div>
              <div className="header-item">Actions</div>
            </div>

            <div className="grid-body">
              {data.slice(0, visibleDataCount).map((item) => (
                <div className="grid-row-two" key={item.PK_BOOKING_ID}>
                  <div>{item.BOOKING_REFERENCE_NO}</div>
                  <div
                    style={{
                      color: item.STATUS === "Pending" ? "red" : item.STATUS === "Cancelled" ? "gray" : "green",
                      fontWeight: "bold",
                    }}
                  >
                    {item.STATUS}
                  </div>
                  <div>
                    {item.isEditing ? (
                      <input
                        type="date"
                        value={item.TRIP_DATE.split("-").reverse().join("-")}
                        onChange={(e) =>
                          setData((prevData) =>
                            prevData.map((i) =>
                              i.PK_BOOKING_ID === item.PK_BOOKING_ID
                                ? { ...i, TRIP_DATE: e.target.value.split("-").reverse().join("-") }
                                : i
                            )
                          )
                        }
                      />
                    ) : (
                      item.date
                    )}
                  </div>
                  <div>{item.DESTINATION}</div>
                  <div>Rs. {item.AMOUNT}</div>
                  <div>
                    <>
                      {item.isEditing ? (
                        <FaSave
                          className={`action-icon ${item.STATUS === "Cancelled" ? "disabled" : ""}`}
                          title="Save"
                          onClick={() =>
                            item.status !== "Cancelled" && confirmDateChange(item.PK_BOOKING_ID, item.TRIP_DATE)
                          }
                          disabled={item.STATUS === "Cancelled"}
                        />
                      ) : (
                        <FaPen
                          className={`action-icon ${item.STATUS === "Cancelled" ? "disabled" : ""}`}
                          title="Edit"
                          onClick={() => item.STATUS !== "Cancelled" && handleEdit(item.PK_BOOKING_ID)}
                          disabled={item.STATUS === "Cancelled"}
                        />
                      )}
                      <FaTimes
                        className={`action-icon ${item.STATUS === "Cancelled" ? "disabled" : ""}`}
                        title="Cancel"
                        onClick={() => item.STATUS !== "Cancelled" && confirmDelete(item.PK_BOOKING_ID)}
                        disabled={item.STATUS === "Cancelled"}
                      />
                      <span className="share-container">
                        <FaShareAlt
                          className={`action-icon ${item.STATUS === "Cancelled" ? "disabled" : ""}`}
                          title="Share"
                          onClick={() => handleShare(item.PK_BOOKING_ID)}
                          disabled={item.STATUS === "Cancelled"}
                        />

                        {showShareOptions === item.PK_BOOKING_ID && (
                          <div className="share-icons">
                            <FaWhatsapp
                              className="whatsapp-icon"
                              title="Share on WhatsApp"
                              onClick={() => shareToWhatsApp(item)}
                            />
                            <FaDownload
                              className="download-icon"
                              title="Download Booking Details"
                              onClick={() => downloadPDF(item)}
                            />
                          </div>
                        )}
                      </span>

                    </>
                  </div>

                </div>
              ))}
            </div>

            {visibleDataCount < data.length && (
              <button className="load-more-button" onClick={handleLoadMore}>
                Load More
              </button>
            )}
          </>
        )}
      </div>

      {showDateConfirmPopup && (
        <div className="delete-popup">
          <div className="popup-content">
            <p>Are you sure you want to change the date?</p>
            <div className="popup-actions">
              <button onClick={handleSave}>Yes</button>
              <button onClick={handleCancelDateChange}>No</button>
            </div>
          </div>
        </div>
      )}

      {showDeletePopup && (
        <div className="delete-popup">
          <div className="popup-content">
            <p>Would you like to cancel this booking?</p>
            <div className="popup-actions">
              <button onClick={handleDelete}>Yes</button>
              <button onClick={handleCancelDelete}>No</button>
            </div>
          </div>
        </div>
      )}

      <div className={`drawer ${isDrawerOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <img src="/images/CIAL_White_Logo.png" alt="Logo" className="drawer-logo" />
        <button className="close-drawer" onClick={toggleDrawer} aria-label="Close Drawer">
          ✕
        </button>
        <ul className="drawer-menu">
          <li onClick={() => navigate("/booking")}>BOOK A TAXI</li>
          <li onClick={() => navigate("/transaction-details")}>TRANSACTION DETAILS</li>
          <li onClick={() => navigate("/faq")}>FAQ</li>
          <li onClick={() => {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/")
          }}>LOG OUT</li>
        </ul>
      </div>
    </div>
  );
};

export default TransactionGrid;
